/**
 * NP-549 — the co-borrower invite token carried by `/login?invite=…`.
 *
 * A co-borrower who already owns a PATH account gets their loan attached by the login POST
 * itself: the token rides along in the request body and the response names the loan. Two
 * places read the query parameter — Login, which forwards it, and PublicOnlyRoute, which
 * must stop bouncing an open session away from the link — so the spelling lives here rather
 * than in both.
 *
 * The value is NOT validated or normalised on the way through. `afn-path-api` treats a
 * whitespace-only, over-long or otherwise unusable token as an absent invitation: the
 * sign-in succeeds and `linkedLoanId` comes back null. An earlier length cap here existed
 * only because the API answered 400 and refused the sign-in on an over-long value, which
 * `afn-path-api` #159 moves into the redeemer; carrying it on afterwards would be the FE
 * propping up a contract that no longer needs it. The token is matched byte for byte, so
 * trimming or re-encoding it here would turn a live invitation into an invalid one.
 */

/** Query-string key on the invite email's login link. */
export const CO_BORROWER_INVITE_PARAM = "invite";
